import axios from "axios";
import axiosRetry from 'axios-retry';

axiosRetry(axios, { retries: 10, retryDelay: axiosRetry.exponentialDelay });

const apiClient = axios.create({
  baseURL: "https://www.strava.com",
  withCredentials: false, // This is the default
  headers: {
  },
});

export default {
  fetchTokens(code) {
    return apiClient.post(
      `/oauth/token?client_id=62596&client_secret=14a17d27f017241d0e804ca5e886918b4dc5faf0&code=${code}&grant_type=authorization_code`
    );
  },
};
